<template>
  <div class="open-app-page">
    <div class="content">
      <div class="icon"></div>
      <div class="text">{{ statusText }}</div>
      <div class="btn-group">
        <div class="btn primary" @click="manualOpenApp">打开应用</div>
        <div class="btn secondary" @click="downloadApp">下载应用</div>
      </div>
    </div>
  </div>
</template>

<script>
import jsCookies from 'js-cookie';

export default {
  name: 'open-app',
  data() {
    return {
      id: '',
      secret: '',
      statusText: '正在打开应用...',
      isIOS: false,
      isAndroid: false
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.secret = this.$route.query.secret;
    this.detectOS();
    this.openApp();
  },
  methods: {
    detectOS() {
      const ua = navigator.userAgent;
      this.isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
      this.isAndroid = /Android/.test(ua);
    },
    getScheme() {
      if (this.isIOS) {
        return `esteelauder://open?id=${this.id}&secret=${this.secret}`;
      } else if (this.isAndroid) {
        return `esteelauder://open?id=${this.id}&secret=${this.secret}`;
      }
      return '';
    },
    getDownloadUrl() {
      if (this.isIOS) {
        return 'https://apps.apple.com/app/id1234567890';
      } else if (this.isAndroid) {
        return 'https://play.google.com/store/apps/details?id=com.bao.app';
      }
      return 'https://www.example.com/download';
    },
    openApp() {
      const scheme = this.getScheme();
      
      if (!scheme) {
        this.statusText = '请使用手机访问';
        return;
      }

      const startTime = Date.now();
      
      if (this.isIOS) {
        window.location.href = scheme;
        
        setTimeout(() => {
          if (Date.now() - startTime < 2500) {
            this.statusText = '应用未安装，正在跳转下载...';
            setTimeout(() => {
              window.location.href = this.getDownloadUrl();
            }, 1000);
          }
        }, 2000);
      } else if (this.isAndroid) {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = scheme;
        document.body.appendChild(iframe);

        setTimeout(() => {
          document.body.removeChild(iframe);
          if (Date.now() - startTime < 2500) {
            this.statusText = '应用未安装，正在跳转下载...';
            setTimeout(() => {
              window.location.href = this.getDownloadUrl();
            }, 1000);
          }
        }, 2000);
      }
    },
    manualOpenApp() {
      this.statusText = '正在打开应用...';
      const scheme = this.getScheme();
      
      if (!scheme) {
        this.statusText = '请使用手机访问';
        return;
      }

      if (this.isIOS) {
        window.location.href = scheme;
      } else if (this.isAndroid) {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = scheme;
        document.body.appendChild(iframe);
        
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 100);
      }
    },
    downloadApp() {
      window.location.href = this.getDownloadUrl();
    }
  }
}
</script>

<style scoped lang="stylus">
.open-app-page
  display flex
  justify-content center
  align-items center
  min-height 100vh
  background-color #f5f5f5
  
  .content
    text-align center
    padding 40px
    
    .icon
      width 80px
      height 80px
      margin 0 auto 20px
      background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
      border-radius 16px
      
    .text
      font-size 16px
      color #666
      margin-bottom 30px
      
    .btn-group
      display flex
      flex-direction column
      gap 16px
      
    .btn
      display inline-block
      padding 12px 40px
      font-size 16px
      border-radius 24px
      cursor pointer
      transition all 0.3s
      
      &.primary
        background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
        color white
        
      &.secondary
        background white
        color #667eea
        border 1px solid #667eea
      
      &:active
        transform scale(0.95)
        opacity 0.8
</style>
